import { Cookie } from '@vue-util/cookie';
import $http from '@vue-util/http';
import { ERROR_CODES } from '@/utils/constants';

const sessionExpiredErrorCodes = ['18050', '02011', '02012', '09007'];
const signInErrorCodes = ERROR_CODES.signInErrorCodes;

function redirect(url) {
  window.location.href = url;
}

function relativeRedirect(relativePath) {
  const currentUrl = window.location.href;
  if (!currentUrl) {
    redirect(relativePath);
    return;
  }
  const urlParts = currentUrl.split(currentUrl);
  redirect(urlParts[0] + relativePath + urlParts[1]);
}

function isResponseObject(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value) && Object.prototype.toString.call(value) === '[object Object]';
}

export default function () {
  $http.interceptors.response.use(
    (response) => {
      const { data } = response;
      // Taking the first key in data object because API response is
      // inside this key. This is a standard response body.
      const parentKey = Object.keys(data)[0];
      if (isResponseObject(data[parentKey]) && 'error' in data[parentKey]) {
        const errorObject = data[parentKey].error;

        if (sessionExpiredErrorCodes.includes(errorObject?.errorCode)) {
          const domain = Cookie.getHostName();
          Cookie.remove('SignedIn', null, {
            domain,
          });
          Cookie.remove('secure_user_token', null, {
            domain,
          });
          Cookie.set('SE', 1, 'SNSGCs', {
            domain,
          });
          Cookie.set('FORWARDPAGE_KEY', window.location, null, {
            domain,
          });
          relativeRedirect('/account/signin');
        }
      }

      return response;
    },
    (error) => {
      let errorCode;
      const { status, data } = error?.response || {};
      if (status === 401) {
        errorCode = data?.user?.error?.errorCode || data?.AggregatorUser?.error?.errorCode || data?.errors?.error[0]?.errorCode || '';
        // If the user uses persistent login and is unable to sign in, do not redirect to sign in page.
        if (signInErrorCodes.includes(errorCode)) {
          return Promise.reject(error);
        }
        const domain = Cookie.getHostName();
        Cookie.remove('SignedIn', null, {
          domain,
        });
        Cookie.set('SE', 1, 'SNSGCs', {
          domain,
        });
        Cookie.set('FORWARDPAGE_KEY', window.location, null, {
          domain,
        });
        relativeRedirect('/account/signin');
      }
      return Promise.reject(error);
    },
  );
}
